import React, { useState, useEffect } from "react";
import Bunexe_service from "../../../Bunexe_service";

const InfoCandidat = ({
  Info_personnelle,
  etapesuivante,
  setMontantAPayer,
  valeurSelectionnee,
  setValeurSeclectionnee,
  setOrderId,
  orderId,
}) => {
  let url_ = Bunexe_service.url;
  const getGeneratedOrderId = () => {
    // e.preventDefault();

    // alert(JSON.stringify(Form_data));
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    try {
      fetch(url_ + `/dossier/e-diplome/generate_order_id`, requestOptions)
        .then((response) => {
          return response.json();
          //else throw Error(response.statusText);
        })
        .then((data) => {
          setOrderId(data.orderId);
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error("Erreur generation orderId ...", error);
    }
    // alert(JSON.stringify(Form_data));
  };

  useEffect(() => {
    getGeneratedOrderId();
  }, []);

  return (
    <div className="container">
      <h4>{valeurSelectionnee}</h4>
      <p>
        {`${Info_personnelle.nom}  ${Info_personnelle.prenom} né(e) le ${
          Info_personnelle.dateNaiss
        } , a participé aux examens du bac ${
          Info_personnelle.Annee
        } et a obtenu la note de ${
          parseInt(Info_personnelle.NotesExtraOrdinaire) > 0
            ? Info_personnelle.NotesExtraOrdinaire
            : Info_personnelle.NotesOrdinaire
        } sur ${Info_personnelle.TotCoef}.
         Mention : ${Info_personnelle.Admis == "O" ? "Admise" : "Echouée"} `}
        {/* Gerald  Belizaire , né(e) le xx/xx/xxxx, a participé aux examens du bac XXX et a obtenu la note de xxx sur xxxx.
         Mention : ${Admis=='O'? "Admise": "Echouée"} */}
      </p>
      <p>Je veux imprimer :</p>
      <div>
        {/* releve */}
        {Info_personnelle.Admis != "O" ? (
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="choix_impression"
              value="releve_seulement"
              id="releve_seulement"
              checked={valeurSelectionnee === "releve_seulement"}
              onChange={(e) => {
                setMontantAPayer("150");
                setValeurSeclectionnee(e.target.value);
              }}
            />
            <label className="form-check-label" for="releve_seulement">
              Relevé seulement ( 150 gourdes)
            </label>
          </div>
        ) : (
          <>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="choix_impression"
                value="releve_seulement"
                id="releve_seulement"
                checked={valeurSelectionnee === "releve_seulement"}
                onChange={(e) => {
                  setMontantAPayer("150");
                  setValeurSeclectionnee(e.target.value);
                }}
              />
              <label className="form-check-label" for="releve_seulement">
                Relevé seulement ( 150 gourdes)
              </label>
            </div>
            {/* Certificat */}
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="choix_impression"
                id="Certificat_seulement"
                value="Certificat_seulement"
                checked={valeurSelectionnee === "Certificat_seulement"}
                onChange={(e) => {
                  setMontantAPayer("250");
                  setValeurSeclectionnee(e.target.value);
                }}
              />
              <label className="form-check-label" for="Certificat_seulement">
                Certificat seulement (250 gourdes)
              </label>
            </div>

            {/* releve et Certificat suelement */}
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="choix_impression"
                id="Releve_Certificat_seulement"
                value="Releve_Certificat_seulement"
                checked={valeurSelectionnee === "Releve_Certificat_seulement"}
                onChange={(e) => {
                  setMontantAPayer("400");
                  setValeurSeclectionnee(e.target.value);
                }}
              />
              <label
                className="form-check-label"
                for="Releve_Certificat_seulement"
              >
                Relevé + Certificat ( 400 gourdes)
              </label>
            </div>

            {/* releve */}
            {/* <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="choix_impression"
                id="releve_legalise_seulement"
                value="releve_legalise_seulement"
                checked={valeurSelectionnee === "releve_legalise_seulement"}
                onChange={(e) => {
                  setMontantAPayer("252");
                  setValeurSeclectionnee(e.target.value);
                }}
              />
              <label
                className="form-check-label"
                for="releve_legalise_seulement"
              >
                Relevé légalisé seulement (252 gourdes)
              </label>
            </div> */}
            {/* releve */}
            {/* <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="choix_impression"
                id="Certificat_legalise_seulement"
                value="Certificat_legalise_seulement"
                checked={valeurSelectionnee === "Certificat_legalise_seulement"}
                onChange={(e) => {
                  setMontantAPayer("352");
                  setValeurSeclectionnee(e.target.value);
                }}
              />
              <label
                className="form-check-label"
                for="Certificat_legalise_seulement"
              >
                Certificat legalisé (352 gourdes)
              </label>
            </div> */}
            {/* releve et Certificat legalisés */}
            {/* <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="choix_impression"
                id="Releve_Certificat_legalise_seulement"
                value="Releve_Certificat_legalise_seulement"
                checked={
                  valeurSelectionnee === "Releve_Certificat_legalise_seulement"
                }
                onChange={(e) => {
                  setMontantAPayer("554");
                  setValeurSeclectionnee(e.target.value);
                }}
              />
              <label
                className="form-check-label"
                for="Releve_Certificat_legalise_seulement"
              >
                Relevé + Certificat legalisés MENFP ( 554 gourdes)
              </label>
            </div> */}

            {/* releve et Certificat legalisés MENFP + MAE*/}
            {/* <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="choix_impression"
                id="Releve_Certificat_legalise_menfp_mae"
                value="Releve_Certificat_legalise_menfp_mae"
                checked={
                  valeurSelectionnee === "Releve_Certificat_legalise_menfp_mae"
                }
                onChange={(e) => {
                  setMontantAPayer("808");
                  setValeurSeclectionnee(e.target.value);
                }}
              />
              <label
                className="form-check-label"
                for="Releve_Certificat_legalise_menfp_mae"
              >
                Relevé + Certificat legalisés MENFP + MAE ( 808 gourdes)
              </label>
            </div> */}
          </>
        )}
        <div className="d-grid gap-1 col-10 mt-4 mx-auto">
          <button
            className="btn btn-primary"
            type="button"
            onClick={etapesuivante}
          >
            Continuer
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoCandidat;
